import { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Step01AutoSendOtp from './steps/Step01AutoSendOtp'
import Step02VerifyOtp from './steps/Step02VerifyOtp'
import Step03FindPresence from './steps/Step03FindPresence'
import Step04Username from './steps/Step04Username'
import Step05AddReleases from './steps/Step05AddReleases'
import Step06Avatar from './steps/Step06Avatar'
import Step07TeamJoin from './steps/Step07TeamJoin'
import Step08TeamUsername from './steps/Step08TeamUsername'
import { OnboardingStep } from './steps/steps'

export type SignupUser = {
  email?: string
  name?: string
  professionRole?: 'artist' | 'manager' | 'support' | string
  plan?: number
  teamMemberPlan?: string
  username?: string
  domain?: string
  avatar?: string | File | null
  social?: Record<string, string>
  topSongs?: any[]
  topVideo?: any
  pendingBandsintownImport?: string
  /** Canonical artist name from Spotify onboarding — source of truth across the platform */
  dizeeArtistName?: string
  /** Set when user landed with ?invited=1 (invited to a team) */
  invitedFromQuery?: boolean
}

export default function SignupPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const query = useMemo(() => new URLSearchParams(location.search), [location.search])

  const email = query.get('email') || undefined
  const from = query.get('from') || '/'
  const invitedFromQuery = query.get('invited') === '1'

  const [step, setStep] = useState<number>(OnboardingStep.AutoSendOtp)
  const [user, setUser] = useState<SignupUser>({ email, invitedFromQuery })

  useEffect(() => {
    if (!email) navigate('/login', { replace: true })
  }, [email, navigate])

  useEffect(() => {
    setUser((prev) => ({ ...prev, email, invitedFromQuery }))
  }, [email, invitedFromQuery])

  // If already authed, skip signup
  useEffect(() => {
    const token = localStorage.getItem('dizeeToken')
    if (token) navigate(from, { replace: true })
  }, [from, navigate])

  return (
    <div className="min-h-screen">
      {step === OnboardingStep.AutoSendOtp && <Step01AutoSendOtp setStep={setStep} user={user} setUser={setUser} />}
      {step === OnboardingStep.VerifyOtp && <Step02VerifyOtp setStep={setStep} user={user} setUser={setUser} />}
      {step === OnboardingStep.FindPresence && <Step03FindPresence setStep={setStep} user={user} setUser={setUser} />}
      {step === OnboardingStep.Username && <Step04Username setStep={setStep} user={user} setUser={setUser} />}
      {step === OnboardingStep.AddReleases && <Step05AddReleases setStep={setStep} user={user} setUser={setUser} />}
      {step === OnboardingStep.Avatar && <Step06Avatar setStep={setStep} user={user} setUser={setUser} from={from} />}
      {step === OnboardingStep.TeamJoin && <Step07TeamJoin setStep={setStep} user={user} setUser={setUser} />}
      {step === OnboardingStep.TeamUsername && <Step08TeamUsername setStep={setStep} user={user} setUser={setUser} />}
    </div>
  )
}

